var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.571 1.874a.857.857 0 0 0-.857.858v18.857a.857.857 0 0 0 .857.857H21.43a.857.857 0 0 0 .857-.857v-7.715a.857.857 0 0 1 1.714 0v7.715a2.571 2.571 0 0 1-2.571 2.571H2.57A2.572 2.572 0 0 1 0 21.59V2.732A2.571 2.571 0 0 1 2.571.16h7.715a.857.857 0 1 1 0 1.714H2.57ZM16.286 1.017c0-.473.383-.857.857-.857h6c.473 0 .857.384.857.857v6a.857.857 0 0 1-1.714 0V1.874h-5.143a.857.857 0 0 1-.857-.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.749.411a.857.857 0 0 1 0 1.212L12.606 12.766a.857.857 0 1 1-1.212-1.212L22.537.411a.857.857 0 0 1 1.212 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .16h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.69ead4bd341c5ce6022d942b4e8bf01d.svg";
export { ForwardRef as ReactComponent };